import React from 'react';
import BoxBody from 'components/BoxBody';
import CoachingCoordinatorCoachList from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorCoachList';
import CoachingCoordinatorParticipantList from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorParticipantList';
import Heading from 'components/Heading';
import TabPanel from 'components/TabPanel';
import Tabs from 'components/Tabs';
import { GetParticipantList_coaching_getParticipantList_participants } from 'coaching/queries/__generated__/GetParticipantList';
import { GetCoachList_coaching_getCoachList_coaches } from 'coaching/queries/__generated__/GetCoachList';

export type ParticipantRow = GetParticipantList_coaching_getParticipantList_participants;
export type CoachRow = GetCoachList_coaching_getCoachList_coaches;

export type Props = {
  loadingParticipants: boolean;
  participants: ParticipantRow[];
  selectedParticipant?: ParticipantRow;
  onNextParticipantPage: () => Promise<void>;
  participantListHasNextPage?: boolean;
  onSelectParticipant: (participant: ParticipantRow) => void;

  loadingCoaches: boolean;
  coaches: CoachRow[];
  coachListHasNextPage?: boolean;
  onNextCoachPage: () => Promise<void>;

  onListTabsChange: (tabIndex: number) => void;
};

export default function CoachingCoordinatorPeopleListView(props: Props) {
  return (
    <>
      <BoxBody>
        <Heading level="1" serif>
          People
        </Heading>
        <Tabs flush={false} onTabChange={props.onListTabsChange}>
          <TabPanel title="Students">
            <CoachingCoordinatorParticipantList
              participants={props.participants}
              loadingParticipants={props.loadingParticipants}
              onSelectParticipant={props.onSelectParticipant}
              onNextPage={props.onNextParticipantPage}
              hasNextPage={props.participantListHasNextPage}
              selectedParticipant={props.selectedParticipant}
            />
          </TabPanel>
          <TabPanel title="Coaches">
            <CoachingCoordinatorCoachList
              coaches={props.coaches}
              loadingCoaches={props.loadingCoaches}
              onNextPage={props.onNextCoachPage}
              hasNextPage={props.coachListHasNextPage}
            />
          </TabPanel>
        </Tabs>
      </BoxBody>
    </>
  );
}
